// Generated from the myc_* queries in modeling_experiments/fec_queries
// (gqueries/modules/multi_year_charts/final_energy_consumption_chart).
// Use > breakdown (per sector / per carrier) > sector or carrier > sub-sector.
// A sector shows its carriers, a carrier shows its sectors.

export default {
  key: 'final_energy_consumption',
  slug: 'final-energy-consumption',
  variants: [
    {
      key: 'fec_total',
      slug: 'total',
      children: [
        {
          key: 'fec_total_per_sector',
          slug: 'per-sector',
          children: [
            {
              key: 'fec_total_sector_all',
              slug: 'all',
              series: [
                'myc_sector_final_consumption_from_households_total',
                'myc_sector_final_consumption_from_buildings_total',
                'myc_sector_final_consumption_from_national_transport_total',
                'myc_sector_final_consumption_from_international_transport_total',
                'myc_sector_final_consumption_from_industry_ex_ict_and_refineries_total',
                'myc_sector_final_consumption_from_industry_ict_total',
                'myc_sector_final_consumption_from_industry_refineries_total',
                'myc_sector_final_consumption_from_agriculture_total',
                'myc_sector_final_consumption_from_energy_total',
                'myc_sector_final_consumption_from_other_total',
              ],
            },
            {
              key: 'fec_total_sector_households',
              slug: 'households',
              series: [
                'myc_sector_final_consumption_of_coal_and_coal_products_in_households_total',
                'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_households_total',
                'myc_sector_final_consumption_of_oil_and_oil_products_in_households_total',
                'myc_sector_final_consumption_of_liquid_biofuels_in_households_total',
                'myc_sector_final_consumption_of_gaseous_biofuels_in_households_total',
                'myc_sector_final_consumption_of_solid_biofuels_in_households_total',
                'myc_sector_final_consumption_of_solar_thermal_in_households_total',
                'myc_sector_final_consumption_of_geothermal_in_households_total',
                'myc_sector_final_consumption_of_renewable_waste_in_households_total',
                'myc_sector_final_consumption_of_non_renewable_waste_in_households_total',
                'myc_sector_final_consumption_of_heat_in_households_total',
                'myc_sector_final_consumption_of_electricity_in_households_total',
                'myc_sector_final_consumption_of_hydrogen_in_households_total',
                'myc_sector_final_consumption_of_ammonia_in_households_total',
                'myc_sector_final_consumption_of_methanol_in_households_total',
              ],
            },
            {
              key: 'fec_total_sector_buildings',
              slug: 'buildings',
              series: [
                'myc_sector_final_consumption_of_coal_and_coal_products_in_buildings_total',
                'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_buildings_total',
                'myc_sector_final_consumption_of_oil_and_oil_products_in_buildings_total',
                'myc_sector_final_consumption_of_liquid_biofuels_in_buildings_total',
                'myc_sector_final_consumption_of_gaseous_biofuels_in_buildings_total',
                'myc_sector_final_consumption_of_solid_biofuels_in_buildings_total',
                'myc_sector_final_consumption_of_solar_thermal_in_buildings_total',
                'myc_sector_final_consumption_of_geothermal_in_buildings_total',
                'myc_sector_final_consumption_of_renewable_waste_in_buildings_total',
                'myc_sector_final_consumption_of_non_renewable_waste_in_buildings_total',
                'myc_sector_final_consumption_of_heat_in_buildings_total',
                'myc_sector_final_consumption_of_electricity_in_buildings_total',
                'myc_sector_final_consumption_of_hydrogen_in_buildings_total',
                'myc_sector_final_consumption_of_ammonia_in_buildings_total',
                'myc_sector_final_consumption_of_methanol_in_buildings_total',
              ],
            },
            {
              key: 'fec_total_sector_national_transport',
              slug: 'national-transport',
              series: [
                'myc_sector_final_consumption_of_coal_and_coal_products_in_national_transport_total',
                'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_national_transport_total',
                'myc_sector_final_consumption_of_oil_and_oil_products_in_national_transport_total',
                'myc_sector_final_consumption_of_liquid_biofuels_in_national_transport_total',
                'myc_sector_final_consumption_of_gaseous_biofuels_in_national_transport_total',
                'myc_sector_final_consumption_of_solid_biofuels_in_national_transport_total',
                'myc_sector_final_consumption_of_solar_thermal_in_national_transport_total',
                'myc_sector_final_consumption_of_geothermal_in_national_transport_total',
                'myc_sector_final_consumption_of_renewable_waste_in_national_transport_total',
                'myc_sector_final_consumption_of_non_renewable_waste_in_national_transport_total',
                'myc_sector_final_consumption_of_heat_in_national_transport_total',
                'myc_sector_final_consumption_of_electricity_in_national_transport_total',
                'myc_sector_final_consumption_of_hydrogen_in_national_transport_total',
                'myc_sector_final_consumption_of_ammonia_in_national_transport_total',
                'myc_sector_final_consumption_of_methanol_in_national_transport_total',
              ],
            },
            {
              key: 'fec_total_sector_international_transport',
              slug: 'international-transport',
              children: [
                {
                  key: 'fec_total_sector_international_transport_all',
                  slug: 'all',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_international_transport_total',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_international_transport_total',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_international_transport_total',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_international_transport_total',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_international_transport_total',
                    'myc_sector_final_consumption_of_solid_biofuels_in_international_transport_total',
                    'myc_sector_final_consumption_of_solar_thermal_in_international_transport_total',
                    'myc_sector_final_consumption_of_geothermal_in_international_transport_total',
                    'myc_sector_final_consumption_of_renewable_waste_in_international_transport_total',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_international_transport_total',
                    'myc_sector_final_consumption_of_heat_in_international_transport_total',
                    'myc_sector_final_consumption_of_electricity_in_international_transport_total',
                    'myc_sector_final_consumption_of_hydrogen_in_international_transport_total',
                    'myc_sector_final_consumption_of_ammonia_in_international_transport_total',
                    'myc_sector_final_consumption_of_methanol_in_international_transport_total',
                  ],
                },
                {
                  key: 'fec_total_sector_bunkers_international_aviation',
                  slug: 'international-aviation',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_bunkers_international_aviation_total',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_bunkers_international_aviation_total',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_bunkers_international_aviation_total',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_bunkers_international_aviation_total',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_bunkers_international_aviation_total',
                    'myc_sector_final_consumption_of_solid_biofuels_in_bunkers_international_aviation_total',
                    'myc_sector_final_consumption_of_solar_thermal_in_bunkers_international_aviation_total',
                    'myc_sector_final_consumption_of_geothermal_in_bunkers_international_aviation_total',
                    'myc_sector_final_consumption_of_renewable_waste_in_bunkers_international_aviation_total',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_bunkers_international_aviation_total',
                    'myc_sector_final_consumption_of_heat_in_bunkers_international_aviation_total',
                    'myc_sector_final_consumption_of_electricity_in_bunkers_international_aviation_total',
                    'myc_sector_final_consumption_of_hydrogen_in_bunkers_international_aviation_total',
                    'myc_sector_final_consumption_of_ammonia_in_bunkers_international_aviation_total',
                    'myc_sector_final_consumption_of_methanol_in_bunkers_international_aviation_total',
                  ],
                },
                {
                  key: 'fec_total_sector_bunkers_international_navigation',
                  slug: 'international-navigation',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_bunkers_international_navigation_total',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_bunkers_international_navigation_total',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_bunkers_international_navigation_total',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_bunkers_international_navigation_total',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_bunkers_international_navigation_total',
                    'myc_sector_final_consumption_of_solid_biofuels_in_bunkers_international_navigation_total',
                    'myc_sector_final_consumption_of_solar_thermal_in_bunkers_international_navigation_total',
                    'myc_sector_final_consumption_of_geothermal_in_bunkers_international_navigation_total',
                    'myc_sector_final_consumption_of_renewable_waste_in_bunkers_international_navigation_total',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_bunkers_international_navigation_total',
                    'myc_sector_final_consumption_of_heat_in_bunkers_international_navigation_total',
                    'myc_sector_final_consumption_of_electricity_in_bunkers_international_navigation_total',
                    'myc_sector_final_consumption_of_hydrogen_in_bunkers_international_navigation_total',
                    'myc_sector_final_consumption_of_ammonia_in_bunkers_international_navigation_total',
                    'myc_sector_final_consumption_of_methanol_in_bunkers_international_navigation_total',
                  ],
                },
              ],
            },
            {
              key: 'fec_total_sector_industry_ex_ict_and_refineries',
              slug: 'industry-ex-ict-and-refineries',
              children: [
                {
                  key: 'fec_total_sector_industry_all',
                  slug: 'all',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_industry_ex_ict_and_refineries_total',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_industry_ex_ict_and_refineries_total',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_industry_ex_ict_and_refineries_total',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_industry_ex_ict_and_refineries_total',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_industry_ex_ict_and_refineries_total',
                    'myc_sector_final_consumption_of_solid_biofuels_in_industry_ex_ict_and_refineries_total',
                    'myc_sector_final_consumption_of_solar_thermal_in_industry_ex_ict_and_refineries_total',
                    'myc_sector_final_consumption_of_geothermal_in_industry_ex_ict_and_refineries_total',
                    'myc_sector_final_consumption_of_renewable_waste_in_industry_ex_ict_and_refineries_total',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_industry_ex_ict_and_refineries_total',
                    'myc_sector_final_consumption_of_heat_in_industry_ex_ict_and_refineries_total',
                    'myc_sector_final_consumption_of_electricity_in_industry_ex_ict_and_refineries_total',
                    'myc_sector_final_consumption_of_hydrogen_in_industry_ex_ict_and_refineries_total',
                    'myc_sector_final_consumption_of_ammonia_in_industry_ex_ict_and_refineries_total',
                    'myc_sector_final_consumption_of_methanol_in_industry_ex_ict_and_refineries_total',
                  ],
                },
                {
                  key: 'fec_total_sector_industry_aluminium',
                  slug: 'aluminium',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_industry_aluminium_total',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_industry_aluminium_total',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_industry_aluminium_total',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_industry_aluminium_total',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_industry_aluminium_total',
                    'myc_sector_final_consumption_of_solid_biofuels_in_industry_aluminium_total',
                    'myc_sector_final_consumption_of_solar_thermal_in_industry_aluminium_total',
                    'myc_sector_final_consumption_of_geothermal_in_industry_aluminium_total',
                    'myc_sector_final_consumption_of_renewable_waste_in_industry_aluminium_total',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_industry_aluminium_total',
                    'myc_sector_final_consumption_of_heat_in_industry_aluminium_total',
                    'myc_sector_final_consumption_of_electricity_in_industry_aluminium_total',
                    'myc_sector_final_consumption_of_hydrogen_in_industry_aluminium_total',
                    'myc_sector_final_consumption_of_ammonia_in_industry_aluminium_total',
                    'myc_sector_final_consumption_of_methanol_in_industry_aluminium_total',
                  ],
                },
                {
                  key: 'fec_total_sector_industry_steel',
                  slug: 'steel',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_industry_steel_total',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_industry_steel_total',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_industry_steel_total',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_industry_steel_total',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_industry_steel_total',
                    'myc_sector_final_consumption_of_solid_biofuels_in_industry_steel_total',
                    'myc_sector_final_consumption_of_solar_thermal_in_industry_steel_total',
                    'myc_sector_final_consumption_of_geothermal_in_industry_steel_total',
                    'myc_sector_final_consumption_of_renewable_waste_in_industry_steel_total',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_industry_steel_total',
                    'myc_sector_final_consumption_of_heat_in_industry_steel_total',
                    'myc_sector_final_consumption_of_electricity_in_industry_steel_total',
                    'myc_sector_final_consumption_of_hydrogen_in_industry_steel_total',
                    'myc_sector_final_consumption_of_ammonia_in_industry_steel_total',
                    'myc_sector_final_consumption_of_methanol_in_industry_steel_total',
                  ],
                },
                {
                  key: 'fec_total_sector_industry_other_metals',
                  slug: 'other-metals',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_industry_other_metals_total',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_industry_other_metals_total',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_industry_other_metals_total',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_industry_other_metals_total',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_industry_other_metals_total',
                    'myc_sector_final_consumption_of_solid_biofuels_in_industry_other_metals_total',
                    'myc_sector_final_consumption_of_solar_thermal_in_industry_other_metals_total',
                    'myc_sector_final_consumption_of_geothermal_in_industry_other_metals_total',
                    'myc_sector_final_consumption_of_renewable_waste_in_industry_other_metals_total',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_industry_other_metals_total',
                    'myc_sector_final_consumption_of_heat_in_industry_other_metals_total',
                    'myc_sector_final_consumption_of_electricity_in_industry_other_metals_total',
                    'myc_sector_final_consumption_of_hydrogen_in_industry_other_metals_total',
                    'myc_sector_final_consumption_of_ammonia_in_industry_other_metals_total',
                    'myc_sector_final_consumption_of_methanol_in_industry_other_metals_total',
                  ],
                },
                {
                  key: 'fec_total_sector_industry_other_chemical',
                  slug: 'other-chemical',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_industry_other_chemical_total',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_industry_other_chemical_total',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_industry_other_chemical_total',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_industry_other_chemical_total',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_industry_other_chemical_total',
                    'myc_sector_final_consumption_of_solid_biofuels_in_industry_other_chemical_total',
                    'myc_sector_final_consumption_of_solar_thermal_in_industry_other_chemical_total',
                    'myc_sector_final_consumption_of_geothermal_in_industry_other_chemical_total',
                    'myc_sector_final_consumption_of_renewable_waste_in_industry_other_chemical_total',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_industry_other_chemical_total',
                    'myc_sector_final_consumption_of_heat_in_industry_other_chemical_total',
                    'myc_sector_final_consumption_of_electricity_in_industry_other_chemical_total',
                    'myc_sector_final_consumption_of_hydrogen_in_industry_other_chemical_total',
                    'myc_sector_final_consumption_of_ammonia_in_industry_other_chemical_total',
                    'myc_sector_final_consumption_of_methanol_in_industry_other_chemical_total',
                  ],
                },
                {
                  key: 'fec_total_sector_industry_fertilizers',
                  slug: 'fertilizers',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_industry_fertilizers_total',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_industry_fertilizers_total',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_industry_fertilizers_total',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_industry_fertilizers_total',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_industry_fertilizers_total',
                    'myc_sector_final_consumption_of_solid_biofuels_in_industry_fertilizers_total',
                    'myc_sector_final_consumption_of_solar_thermal_in_industry_fertilizers_total',
                    'myc_sector_final_consumption_of_geothermal_in_industry_fertilizers_total',
                    'myc_sector_final_consumption_of_renewable_waste_in_industry_fertilizers_total',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_industry_fertilizers_total',
                    'myc_sector_final_consumption_of_heat_in_industry_fertilizers_total',
                    'myc_sector_final_consumption_of_electricity_in_industry_fertilizers_total',
                    'myc_sector_final_consumption_of_hydrogen_in_industry_fertilizers_total',
                    'myc_sector_final_consumption_of_ammonia_in_industry_fertilizers_total',
                    'myc_sector_final_consumption_of_methanol_in_industry_fertilizers_total',
                  ],
                },
                {
                  key: 'fec_total_sector_industry_paper',
                  slug: 'paper',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_industry_paper_total',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_industry_paper_total',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_industry_paper_total',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_industry_paper_total',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_industry_paper_total',
                    'myc_sector_final_consumption_of_solid_biofuels_in_industry_paper_total',
                    'myc_sector_final_consumption_of_solar_thermal_in_industry_paper_total',
                    'myc_sector_final_consumption_of_geothermal_in_industry_paper_total',
                    'myc_sector_final_consumption_of_renewable_waste_in_industry_paper_total',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_industry_paper_total',
                    'myc_sector_final_consumption_of_heat_in_industry_paper_total',
                    'myc_sector_final_consumption_of_electricity_in_industry_paper_total',
                    'myc_sector_final_consumption_of_hydrogen_in_industry_paper_total',
                    'myc_sector_final_consumption_of_ammonia_in_industry_paper_total',
                    'myc_sector_final_consumption_of_methanol_in_industry_paper_total',
                  ],
                },
                {
                  key: 'fec_total_sector_industry_food',
                  slug: 'food',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_industry_food_total',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_industry_food_total',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_industry_food_total',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_industry_food_total',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_industry_food_total',
                    'myc_sector_final_consumption_of_solid_biofuels_in_industry_food_total',
                    'myc_sector_final_consumption_of_solar_thermal_in_industry_food_total',
                    'myc_sector_final_consumption_of_geothermal_in_industry_food_total',
                    'myc_sector_final_consumption_of_renewable_waste_in_industry_food_total',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_industry_food_total',
                    'myc_sector_final_consumption_of_heat_in_industry_food_total',
                    'myc_sector_final_consumption_of_electricity_in_industry_food_total',
                    'myc_sector_final_consumption_of_hydrogen_in_industry_food_total',
                    'myc_sector_final_consumption_of_ammonia_in_industry_food_total',
                    'myc_sector_final_consumption_of_methanol_in_industry_food_total',
                  ],
                },
                {
                  key: 'fec_total_sector_industry_other_non_specified',
                  slug: 'other-non-specified',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_industry_other_non_specified_total',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_industry_other_non_specified_total',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_industry_other_non_specified_total',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_industry_other_non_specified_total',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_industry_other_non_specified_total',
                    'myc_sector_final_consumption_of_solid_biofuels_in_industry_other_non_specified_total',
                    'myc_sector_final_consumption_of_solar_thermal_in_industry_other_non_specified_total',
                    'myc_sector_final_consumption_of_geothermal_in_industry_other_non_specified_total',
                    'myc_sector_final_consumption_of_renewable_waste_in_industry_other_non_specified_total',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_industry_other_non_specified_total',
                    'myc_sector_final_consumption_of_heat_in_industry_other_non_specified_total',
                    'myc_sector_final_consumption_of_electricity_in_industry_other_non_specified_total',
                    'myc_sector_final_consumption_of_hydrogen_in_industry_other_non_specified_total',
                    'myc_sector_final_consumption_of_ammonia_in_industry_other_non_specified_total',
                    'myc_sector_final_consumption_of_methanol_in_industry_other_non_specified_total',
                  ],
                },
              ],
            },
            {
              key: 'fec_total_sector_industry_ict',
              slug: 'industry-ict',
              series: [
                'myc_sector_final_consumption_of_coal_and_coal_products_in_industry_ict_total',
                'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_industry_ict_total',
                'myc_sector_final_consumption_of_oil_and_oil_products_in_industry_ict_total',
                'myc_sector_final_consumption_of_liquid_biofuels_in_industry_ict_total',
                'myc_sector_final_consumption_of_gaseous_biofuels_in_industry_ict_total',
                'myc_sector_final_consumption_of_solid_biofuels_in_industry_ict_total',
                'myc_sector_final_consumption_of_solar_thermal_in_industry_ict_total',
                'myc_sector_final_consumption_of_geothermal_in_industry_ict_total',
                'myc_sector_final_consumption_of_renewable_waste_in_industry_ict_total',
                'myc_sector_final_consumption_of_non_renewable_waste_in_industry_ict_total',
                'myc_sector_final_consumption_of_heat_in_industry_ict_total',
                'myc_sector_final_consumption_of_electricity_in_industry_ict_total',
                'myc_sector_final_consumption_of_hydrogen_in_industry_ict_total',
                'myc_sector_final_consumption_of_ammonia_in_industry_ict_total',
                'myc_sector_final_consumption_of_methanol_in_industry_ict_total',
              ],
            },
            {
              key: 'fec_total_sector_industry_refineries',
              slug: 'industry-refineries',
              series: [
                'myc_sector_final_consumption_of_coal_and_coal_products_in_industry_refineries_total',
                'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_industry_refineries_total',
                'myc_sector_final_consumption_of_oil_and_oil_products_in_industry_refineries_total',
                'myc_sector_final_consumption_of_liquid_biofuels_in_industry_refineries_total',
                'myc_sector_final_consumption_of_gaseous_biofuels_in_industry_refineries_total',
                'myc_sector_final_consumption_of_solid_biofuels_in_industry_refineries_total',
                'myc_sector_final_consumption_of_solar_thermal_in_industry_refineries_total',
                'myc_sector_final_consumption_of_geothermal_in_industry_refineries_total',
                'myc_sector_final_consumption_of_renewable_waste_in_industry_refineries_total',
                'myc_sector_final_consumption_of_non_renewable_waste_in_industry_refineries_total',
                'myc_sector_final_consumption_of_heat_in_industry_refineries_total',
                'myc_sector_final_consumption_of_electricity_in_industry_refineries_total',
                'myc_sector_final_consumption_of_hydrogen_in_industry_refineries_total',
                'myc_sector_final_consumption_of_ammonia_in_industry_refineries_total',
                'myc_sector_final_consumption_of_methanol_in_industry_refineries_total',
              ],
            },
            {
              key: 'fec_total_sector_agriculture',
              slug: 'agriculture',
              series: [
                'myc_sector_final_consumption_of_coal_and_coal_products_in_agriculture_total',
                'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_agriculture_total',
                'myc_sector_final_consumption_of_oil_and_oil_products_in_agriculture_total',
                'myc_sector_final_consumption_of_liquid_biofuels_in_agriculture_total',
                'myc_sector_final_consumption_of_gaseous_biofuels_in_agriculture_total',
                'myc_sector_final_consumption_of_solid_biofuels_in_agriculture_total',
                'myc_sector_final_consumption_of_solar_thermal_in_agriculture_total',
                'myc_sector_final_consumption_of_geothermal_in_agriculture_total',
                'myc_sector_final_consumption_of_renewable_waste_in_agriculture_total',
                'myc_sector_final_consumption_of_non_renewable_waste_in_agriculture_total',
                'myc_sector_final_consumption_of_heat_in_agriculture_total',
                'myc_sector_final_consumption_of_electricity_in_agriculture_total',
                'myc_sector_final_consumption_of_hydrogen_in_agriculture_total',
                'myc_sector_final_consumption_of_ammonia_in_agriculture_total',
                'myc_sector_final_consumption_of_methanol_in_agriculture_total',
              ],
            },
            {
              key: 'fec_total_sector_energy',
              slug: 'energy',
              series: [
                'myc_sector_final_consumption_of_coal_and_coal_products_in_energy_total',
                'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_energy_total',
                'myc_sector_final_consumption_of_oil_and_oil_products_in_energy_total',
                'myc_sector_final_consumption_of_liquid_biofuels_in_energy_total',
                'myc_sector_final_consumption_of_gaseous_biofuels_in_energy_total',
                'myc_sector_final_consumption_of_solid_biofuels_in_energy_total',
                'myc_sector_final_consumption_of_solar_thermal_in_energy_total',
                'myc_sector_final_consumption_of_geothermal_in_energy_total',
                'myc_sector_final_consumption_of_renewable_waste_in_energy_total',
                'myc_sector_final_consumption_of_non_renewable_waste_in_energy_total',
                'myc_sector_final_consumption_of_heat_in_energy_total',
                'myc_sector_final_consumption_of_electricity_in_energy_total',
                'myc_sector_final_consumption_of_hydrogen_in_energy_total',
                'myc_sector_final_consumption_of_ammonia_in_energy_total',
                'myc_sector_final_consumption_of_methanol_in_energy_total',
              ],
            },
            {
              key: 'fec_total_sector_other',
              slug: 'other',
              series: [
                'myc_sector_final_consumption_of_coal_and_coal_products_in_other_total',
                'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_other_total',
                'myc_sector_final_consumption_of_oil_and_oil_products_in_other_total',
                'myc_sector_final_consumption_of_liquid_biofuels_in_other_total',
                'myc_sector_final_consumption_of_gaseous_biofuels_in_other_total',
                'myc_sector_final_consumption_of_solid_biofuels_in_other_total',
                'myc_sector_final_consumption_of_solar_thermal_in_other_total',
                'myc_sector_final_consumption_of_geothermal_in_other_total',
                'myc_sector_final_consumption_of_renewable_waste_in_other_total',
                'myc_sector_final_consumption_of_non_renewable_waste_in_other_total',
                'myc_sector_final_consumption_of_heat_in_other_total',
                'myc_sector_final_consumption_of_electricity_in_other_total',
                'myc_sector_final_consumption_of_hydrogen_in_other_total',
                'myc_sector_final_consumption_of_ammonia_in_other_total',
                'myc_sector_final_consumption_of_methanol_in_other_total',
              ],
            },
          ],
        },
        {
          key: 'fec_total_per_carrier',
          slug: 'per-carrier',
          children: [
            {
              key: 'fec_total_carrier_all',
              slug: 'all',
              series: [
                'myc_carrier_final_consumption_of_coal_and_coal_products_total',
                'myc_carrier_final_consumption_of_natural_gas_and_gas_products_total',
                'myc_carrier_final_consumption_of_oil_and_oil_products_total',
                'myc_carrier_final_consumption_of_liquid_biofuels_total',
                'myc_carrier_final_consumption_of_gaseous_biofuels_total',
                'myc_carrier_final_consumption_of_solid_biofuels_total',
                'myc_carrier_final_consumption_of_solar_thermal_total',
                'myc_carrier_final_consumption_of_geothermal_total',
                'myc_carrier_final_consumption_of_renewable_waste_total',
                'myc_carrier_final_consumption_of_non_renewable_waste_total',
                'myc_carrier_final_consumption_of_heat_total',
                'myc_carrier_final_consumption_of_electricity_total',
                'myc_carrier_final_consumption_of_hydrogen_total',
                'myc_carrier_final_consumption_of_ammonia_total',
                'myc_carrier_final_consumption_of_methanol_total',
              ],
            },
            {
              key: 'fec_total_carrier_coal_and_coal_products',
              slug: 'coal-and-coal-products',
              series: [
                'myc_carrier_final_consumption_of_coal_and_coal_products_in_households_total',
                'myc_carrier_final_consumption_of_coal_and_coal_products_in_buildings_total',
                'myc_carrier_final_consumption_of_coal_and_coal_products_in_national_transport_total',
                'myc_carrier_final_consumption_of_coal_and_coal_products_in_international_transport_total',
                'myc_carrier_final_consumption_of_coal_and_coal_products_in_industry_ex_ict_and_refineries_total',
                'myc_carrier_final_consumption_of_coal_and_coal_products_in_industry_ict_total',
                'myc_carrier_final_consumption_of_coal_and_coal_products_in_industry_refineries_total',
                'myc_carrier_final_consumption_of_coal_and_coal_products_in_agriculture_total',
                'myc_carrier_final_consumption_of_coal_and_coal_products_in_energy_total',
                'myc_carrier_final_consumption_of_coal_and_coal_products_in_other_total',
              ],
            },
            {
              key: 'fec_total_carrier_natural_gas_and_gas_products',
              slug: 'natural-gas-and-gas-products',
              series: [
                'myc_carrier_final_consumption_of_natural_gas_and_gas_products_in_households_total',
                'myc_carrier_final_consumption_of_natural_gas_and_gas_products_in_buildings_total',
                'myc_carrier_final_consumption_of_natural_gas_and_gas_products_in_national_transport_total',
                'myc_carrier_final_consumption_of_natural_gas_and_gas_products_in_international_transport_total',
                'myc_carrier_final_consumption_of_natural_gas_and_gas_products_in_industry_ex_ict_and_refineries_total',
                'myc_carrier_final_consumption_of_natural_gas_and_gas_products_in_industry_ict_total',
                'myc_carrier_final_consumption_of_natural_gas_and_gas_products_in_industry_refineries_total',
                'myc_carrier_final_consumption_of_natural_gas_and_gas_products_in_agriculture_total',
                'myc_carrier_final_consumption_of_natural_gas_and_gas_products_in_energy_total',
                'myc_carrier_final_consumption_of_natural_gas_and_gas_products_in_other_total',
              ],
            },
            {
              key: 'fec_total_carrier_oil_and_oil_products',
              slug: 'oil-and-oil-products',
              series: [
                'myc_carrier_final_consumption_of_oil_and_oil_products_in_households_total',
                'myc_carrier_final_consumption_of_oil_and_oil_products_in_buildings_total',
                'myc_carrier_final_consumption_of_oil_and_oil_products_in_national_transport_total',
                'myc_carrier_final_consumption_of_oil_and_oil_products_in_international_transport_total',
                'myc_carrier_final_consumption_of_oil_and_oil_products_in_industry_ex_ict_and_refineries_total',
                'myc_carrier_final_consumption_of_oil_and_oil_products_in_industry_ict_total',
                'myc_carrier_final_consumption_of_oil_and_oil_products_in_industry_refineries_total',
                'myc_carrier_final_consumption_of_oil_and_oil_products_in_agriculture_total',
                'myc_carrier_final_consumption_of_oil_and_oil_products_in_energy_total',
                'myc_carrier_final_consumption_of_oil_and_oil_products_in_other_total',
              ],
            },
            {
              key: 'fec_total_carrier_liquid_biofuels',
              slug: 'liquid-biofuels',
              series: [
                'myc_carrier_final_consumption_of_liquid_biofuels_in_households_total',
                'myc_carrier_final_consumption_of_liquid_biofuels_in_buildings_total',
                'myc_carrier_final_consumption_of_liquid_biofuels_in_national_transport_total',
                'myc_carrier_final_consumption_of_liquid_biofuels_in_international_transport_total',
                'myc_carrier_final_consumption_of_liquid_biofuels_in_industry_ex_ict_and_refineries_total',
                'myc_carrier_final_consumption_of_liquid_biofuels_in_industry_ict_total',
                'myc_carrier_final_consumption_of_liquid_biofuels_in_industry_refineries_total',
                'myc_carrier_final_consumption_of_liquid_biofuels_in_agriculture_total',
                'myc_carrier_final_consumption_of_liquid_biofuels_in_energy_total',
                'myc_carrier_final_consumption_of_liquid_biofuels_in_other_total',
              ],
            },
            {
              key: 'fec_total_carrier_gaseous_biofuels',
              slug: 'gaseous-biofuels',
              series: [
                'myc_carrier_final_consumption_of_gaseous_biofuels_in_households_total',
                'myc_carrier_final_consumption_of_gaseous_biofuels_in_buildings_total',
                'myc_carrier_final_consumption_of_gaseous_biofuels_in_national_transport_total',
                'myc_carrier_final_consumption_of_gaseous_biofuels_in_international_transport_total',
                'myc_carrier_final_consumption_of_gaseous_biofuels_in_industry_ex_ict_and_refineries_total',
                'myc_carrier_final_consumption_of_gaseous_biofuels_in_industry_ict_total',
                'myc_carrier_final_consumption_of_gaseous_biofuels_in_industry_refineries_total',
                'myc_carrier_final_consumption_of_gaseous_biofuels_in_agriculture_total',
                'myc_carrier_final_consumption_of_gaseous_biofuels_in_energy_total',
                'myc_carrier_final_consumption_of_gaseous_biofuels_in_other_total',
              ],
            },
            {
              key: 'fec_total_carrier_solid_biofuels',
              slug: 'solid-biofuels',
              series: [
                'myc_carrier_final_consumption_of_solid_biofuels_in_households_total',
                'myc_carrier_final_consumption_of_solid_biofuels_in_buildings_total',
                'myc_carrier_final_consumption_of_solid_biofuels_in_national_transport_total',
                'myc_carrier_final_consumption_of_solid_biofuels_in_international_transport_total',
                'myc_carrier_final_consumption_of_solid_biofuels_in_industry_ex_ict_and_refineries_total',
                'myc_carrier_final_consumption_of_solid_biofuels_in_industry_ict_total',
                'myc_carrier_final_consumption_of_solid_biofuels_in_industry_refineries_total',
                'myc_carrier_final_consumption_of_solid_biofuels_in_agriculture_total',
                'myc_carrier_final_consumption_of_solid_biofuels_in_energy_total',
                'myc_carrier_final_consumption_of_solid_biofuels_in_other_total',
              ],
            },
            {
              key: 'fec_total_carrier_solar_thermal',
              slug: 'solar-thermal',
              series: [
                'myc_carrier_final_consumption_of_solar_thermal_in_households_total',
                'myc_carrier_final_consumption_of_solar_thermal_in_buildings_total',
                'myc_carrier_final_consumption_of_solar_thermal_in_national_transport_total',
                'myc_carrier_final_consumption_of_solar_thermal_in_international_transport_total',
                'myc_carrier_final_consumption_of_solar_thermal_in_industry_ex_ict_and_refineries_total',
                'myc_carrier_final_consumption_of_solar_thermal_in_industry_ict_total',
                'myc_carrier_final_consumption_of_solar_thermal_in_industry_refineries_total',
                'myc_carrier_final_consumption_of_solar_thermal_in_agriculture_total',
                'myc_carrier_final_consumption_of_solar_thermal_in_energy_total',
                'myc_carrier_final_consumption_of_solar_thermal_in_other_total',
              ],
            },
            {
              key: 'fec_total_carrier_geothermal',
              slug: 'geothermal',
              series: [
                'myc_carrier_final_consumption_of_geothermal_in_households_total',
                'myc_carrier_final_consumption_of_geothermal_in_buildings_total',
                'myc_carrier_final_consumption_of_geothermal_in_national_transport_total',
                'myc_carrier_final_consumption_of_geothermal_in_international_transport_total',
                'myc_carrier_final_consumption_of_geothermal_in_industry_ex_ict_and_refineries_total',
                'myc_carrier_final_consumption_of_geothermal_in_industry_ict_total',
                'myc_carrier_final_consumption_of_geothermal_in_industry_refineries_total',
                'myc_carrier_final_consumption_of_geothermal_in_agriculture_total',
                'myc_carrier_final_consumption_of_geothermal_in_energy_total',
                'myc_carrier_final_consumption_of_geothermal_in_other_total',
              ],
            },
            {
              key: 'fec_total_carrier_renewable_waste',
              slug: 'renewable-waste',
              series: [
                'myc_carrier_final_consumption_of_renewable_waste_in_households_total',
                'myc_carrier_final_consumption_of_renewable_waste_in_buildings_total',
                'myc_carrier_final_consumption_of_renewable_waste_in_national_transport_total',
                'myc_carrier_final_consumption_of_renewable_waste_in_international_transport_total',
                'myc_carrier_final_consumption_of_renewable_waste_in_industry_ex_ict_and_refineries_total',
                'myc_carrier_final_consumption_of_renewable_waste_in_industry_ict_total',
                'myc_carrier_final_consumption_of_renewable_waste_in_industry_refineries_total',
                'myc_carrier_final_consumption_of_renewable_waste_in_agriculture_total',
                'myc_carrier_final_consumption_of_renewable_waste_in_energy_total',
                'myc_carrier_final_consumption_of_renewable_waste_in_other_total',
              ],
            },
            {
              key: 'fec_total_carrier_non_renewable_waste',
              slug: 'non-renewable-waste',
              series: [
                'myc_carrier_final_consumption_of_non_renewable_waste_in_households_total',
                'myc_carrier_final_consumption_of_non_renewable_waste_in_buildings_total',
                'myc_carrier_final_consumption_of_non_renewable_waste_in_national_transport_total',
                'myc_carrier_final_consumption_of_non_renewable_waste_in_international_transport_total',
                'myc_carrier_final_consumption_of_non_renewable_waste_in_industry_ex_ict_and_refineries_total',
                'myc_carrier_final_consumption_of_non_renewable_waste_in_industry_ict_total',
                'myc_carrier_final_consumption_of_non_renewable_waste_in_industry_refineries_total',
                'myc_carrier_final_consumption_of_non_renewable_waste_in_agriculture_total',
                'myc_carrier_final_consumption_of_non_renewable_waste_in_energy_total',
                'myc_carrier_final_consumption_of_non_renewable_waste_in_other_total',
              ],
            },
            {
              key: 'fec_total_carrier_heat',
              slug: 'heat',
              series: [
                'myc_carrier_final_consumption_of_heat_in_households_total',
                'myc_carrier_final_consumption_of_heat_in_buildings_total',
                'myc_carrier_final_consumption_of_heat_in_national_transport_total',
                'myc_carrier_final_consumption_of_heat_in_international_transport_total',
                'myc_carrier_final_consumption_of_heat_in_industry_ex_ict_and_refineries_total',
                'myc_carrier_final_consumption_of_heat_in_industry_ict_total',
                'myc_carrier_final_consumption_of_heat_in_industry_refineries_total',
                'myc_carrier_final_consumption_of_heat_in_agriculture_total',
                'myc_carrier_final_consumption_of_heat_in_energy_total',
                'myc_carrier_final_consumption_of_heat_in_other_total',
              ],
            },
            {
              key: 'fec_total_carrier_electricity',
              slug: 'electricity',
              series: [
                'myc_carrier_final_consumption_of_electricity_in_households_total',
                'myc_carrier_final_consumption_of_electricity_in_buildings_total',
                'myc_carrier_final_consumption_of_electricity_in_national_transport_total',
                'myc_carrier_final_consumption_of_electricity_in_international_transport_total',
                'myc_carrier_final_consumption_of_electricity_in_industry_ex_ict_and_refineries_total',
                'myc_carrier_final_consumption_of_electricity_in_industry_ict_total',
                'myc_carrier_final_consumption_of_electricity_in_industry_refineries_total',
                'myc_carrier_final_consumption_of_electricity_in_agriculture_total',
                'myc_carrier_final_consumption_of_electricity_in_energy_total',
                'myc_carrier_final_consumption_of_electricity_in_other_total',
              ],
            },
            {
              key: 'fec_total_carrier_hydrogen',
              slug: 'hydrogen',
              series: [
                'myc_carrier_final_consumption_of_hydrogen_in_households_total',
                'myc_carrier_final_consumption_of_hydrogen_in_buildings_total',
                'myc_carrier_final_consumption_of_hydrogen_in_national_transport_total',
                'myc_carrier_final_consumption_of_hydrogen_in_international_transport_total',
                'myc_carrier_final_consumption_of_hydrogen_in_industry_ex_ict_and_refineries_total',
                'myc_carrier_final_consumption_of_hydrogen_in_industry_ict_total',
                'myc_carrier_final_consumption_of_hydrogen_in_industry_refineries_total',
                'myc_carrier_final_consumption_of_hydrogen_in_agriculture_total',
                'myc_carrier_final_consumption_of_hydrogen_in_energy_total',
                'myc_carrier_final_consumption_of_hydrogen_in_other_total',
              ],
            },
            {
              key: 'fec_total_carrier_ammonia',
              slug: 'ammonia',
              series: [
                'myc_carrier_final_consumption_of_ammonia_in_households_total',
                'myc_carrier_final_consumption_of_ammonia_in_buildings_total',
                'myc_carrier_final_consumption_of_ammonia_in_national_transport_total',
                'myc_carrier_final_consumption_of_ammonia_in_international_transport_total',
                'myc_carrier_final_consumption_of_ammonia_in_industry_ex_ict_and_refineries_total',
                'myc_carrier_final_consumption_of_ammonia_in_industry_ict_total',
                'myc_carrier_final_consumption_of_ammonia_in_industry_refineries_total',
                'myc_carrier_final_consumption_of_ammonia_in_agriculture_total',
                'myc_carrier_final_consumption_of_ammonia_in_energy_total',
                'myc_carrier_final_consumption_of_ammonia_in_other_total',
              ],
            },
            {
              key: 'fec_total_carrier_methanol',
              slug: 'methanol',
              series: [
                'myc_carrier_final_consumption_of_methanol_in_households_total',
                'myc_carrier_final_consumption_of_methanol_in_buildings_total',
                'myc_carrier_final_consumption_of_methanol_in_national_transport_total',
                'myc_carrier_final_consumption_of_methanol_in_international_transport_total',
                'myc_carrier_final_consumption_of_methanol_in_industry_ex_ict_and_refineries_total',
                'myc_carrier_final_consumption_of_methanol_in_industry_ict_total',
                'myc_carrier_final_consumption_of_methanol_in_industry_refineries_total',
                'myc_carrier_final_consumption_of_methanol_in_agriculture_total',
                'myc_carrier_final_consumption_of_methanol_in_energy_total',
                'myc_carrier_final_consumption_of_methanol_in_other_total',
              ],
            },
          ],
        },
      ],
    },
    {
      key: 'fec_energetic',
      slug: 'energetic',
      children: [
        {
          key: 'fec_energetic_per_sector',
          slug: 'per-sector',
          children: [
            {
              key: 'fec_energetic_sector_all',
              slug: 'all',
              series: [
                'myc_sector_final_consumption_from_households_energetic',
                'myc_sector_final_consumption_from_buildings_energetic',
                'myc_sector_final_consumption_from_national_transport_energetic',
                'myc_sector_final_consumption_from_international_transport_energetic',
                'myc_sector_final_consumption_from_industry_ex_ict_and_refineries_energetic',
                'myc_sector_final_consumption_from_industry_ict_energetic',
                'myc_sector_final_consumption_from_industry_refineries_energetic',
                'myc_sector_final_consumption_from_agriculture_energetic',
                'myc_sector_final_consumption_from_energy_energetic',
                'myc_sector_final_consumption_from_other_energetic',
              ],
            },
            {
              key: 'fec_energetic_sector_households',
              slug: 'households',
              series: [
                'myc_sector_final_consumption_of_coal_and_coal_products_in_households_energetic',
                'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_households_energetic',
                'myc_sector_final_consumption_of_oil_and_oil_products_in_households_energetic',
                'myc_sector_final_consumption_of_liquid_biofuels_in_households_energetic',
                'myc_sector_final_consumption_of_gaseous_biofuels_in_households_energetic',
                'myc_sector_final_consumption_of_solid_biofuels_in_households_energetic',
                'myc_sector_final_consumption_of_solar_thermal_in_households_energetic',
                'myc_sector_final_consumption_of_geothermal_in_households_energetic',
                'myc_sector_final_consumption_of_renewable_waste_in_households_energetic',
                'myc_sector_final_consumption_of_non_renewable_waste_in_households_energetic',
                'myc_sector_final_consumption_of_heat_in_households_energetic',
                'myc_sector_final_consumption_of_electricity_in_households_energetic',
                'myc_sector_final_consumption_of_hydrogen_in_households_energetic',
                'myc_sector_final_consumption_of_ammonia_in_households_energetic',
                'myc_sector_final_consumption_of_methanol_in_households_energetic',
              ],
            },
            {
              key: 'fec_energetic_sector_buildings',
              slug: 'buildings',
              series: [
                'myc_sector_final_consumption_of_coal_and_coal_products_in_buildings_energetic',
                'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_buildings_energetic',
                'myc_sector_final_consumption_of_oil_and_oil_products_in_buildings_energetic',
                'myc_sector_final_consumption_of_liquid_biofuels_in_buildings_energetic',
                'myc_sector_final_consumption_of_gaseous_biofuels_in_buildings_energetic',
                'myc_sector_final_consumption_of_solid_biofuels_in_buildings_energetic',
                'myc_sector_final_consumption_of_solar_thermal_in_buildings_energetic',
                'myc_sector_final_consumption_of_geothermal_in_buildings_energetic',
                'myc_sector_final_consumption_of_renewable_waste_in_buildings_energetic',
                'myc_sector_final_consumption_of_non_renewable_waste_in_buildings_energetic',
                'myc_sector_final_consumption_of_heat_in_buildings_energetic',
                'myc_sector_final_consumption_of_electricity_in_buildings_energetic',
                'myc_sector_final_consumption_of_hydrogen_in_buildings_energetic',
                'myc_sector_final_consumption_of_ammonia_in_buildings_energetic',
                'myc_sector_final_consumption_of_methanol_in_buildings_energetic',
              ],
            },
            {
              key: 'fec_energetic_sector_national_transport',
              slug: 'national-transport',
              series: [
                'myc_sector_final_consumption_of_coal_and_coal_products_in_national_transport_energetic',
                'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_national_transport_energetic',
                'myc_sector_final_consumption_of_oil_and_oil_products_in_national_transport_energetic',
                'myc_sector_final_consumption_of_liquid_biofuels_in_national_transport_energetic',
                'myc_sector_final_consumption_of_gaseous_biofuels_in_national_transport_energetic',
                'myc_sector_final_consumption_of_solid_biofuels_in_national_transport_energetic',
                'myc_sector_final_consumption_of_solar_thermal_in_national_transport_energetic',
                'myc_sector_final_consumption_of_geothermal_in_national_transport_energetic',
                'myc_sector_final_consumption_of_renewable_waste_in_national_transport_energetic',
                'myc_sector_final_consumption_of_non_renewable_waste_in_national_transport_energetic',
                'myc_sector_final_consumption_of_heat_in_national_transport_energetic',
                'myc_sector_final_consumption_of_electricity_in_national_transport_energetic',
                'myc_sector_final_consumption_of_hydrogen_in_national_transport_energetic',
                'myc_sector_final_consumption_of_ammonia_in_national_transport_energetic',
                'myc_sector_final_consumption_of_methanol_in_national_transport_energetic',
              ],
            },
            {
              key: 'fec_energetic_sector_international_transport',
              slug: 'international-transport',
              children: [
                {
                  key: 'fec_energetic_sector_bunkers_all',
                  slug: 'all',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_international_transport_energetic',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_international_transport_energetic',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_international_transport_energetic',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_international_transport_energetic',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_international_transport_energetic',
                    'myc_sector_final_consumption_of_solid_biofuels_in_international_transport_energetic',
                    'myc_sector_final_consumption_of_solar_thermal_in_international_transport_energetic',
                    'myc_sector_final_consumption_of_geothermal_in_international_transport_energetic',
                    'myc_sector_final_consumption_of_renewable_waste_in_international_transport_energetic',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_international_transport_energetic',
                    'myc_sector_final_consumption_of_heat_in_international_transport_energetic',
                    'myc_sector_final_consumption_of_electricity_in_international_transport_energetic',
                    'myc_sector_final_consumption_of_hydrogen_in_international_transport_energetic',
                    'myc_sector_final_consumption_of_ammonia_in_international_transport_energetic',
                    'myc_sector_final_consumption_of_methanol_in_international_transport_energetic',
                  ],
                },
                {
                  key: 'fec_energetic_sector_bunkers_international_aviation',
                  slug: 'international-aviation',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_bunkers_international_aviation_energetic',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_bunkers_international_aviation_energetic',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_bunkers_international_aviation_energetic',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_bunkers_international_aviation_energetic',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_bunkers_international_aviation_energetic',
                    'myc_sector_final_consumption_of_solid_biofuels_in_bunkers_international_aviation_energetic',
                    'myc_sector_final_consumption_of_solar_thermal_in_bunkers_international_aviation_energetic',
                    'myc_sector_final_consumption_of_geothermal_in_bunkers_international_aviation_energetic',
                    'myc_sector_final_consumption_of_renewable_waste_in_bunkers_international_aviation_energetic',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_bunkers_international_aviation_energetic',
                    'myc_sector_final_consumption_of_heat_in_bunkers_international_aviation_energetic',
                    'myc_sector_final_consumption_of_electricity_in_bunkers_international_aviation_energetic',
                    'myc_sector_final_consumption_of_hydrogen_in_bunkers_international_aviation_energetic',
                    'myc_sector_final_consumption_of_ammonia_in_bunkers_international_aviation_energetic',
                    'myc_sector_final_consumption_of_methanol_in_bunkers_international_aviation_energetic',
                  ],
                },
                {
                  key: 'fec_energetic_sector_bunkers_international_navigation',
                  slug: 'international-navigation',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_bunkers_international_navigation_energetic',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_bunkers_international_navigation_energetic',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_bunkers_international_navigation_energetic',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_bunkers_international_navigation_energetic',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_bunkers_international_navigation_energetic',
                    'myc_sector_final_consumption_of_solid_biofuels_in_bunkers_international_navigation_energetic',
                    'myc_sector_final_consumption_of_solar_thermal_in_bunkers_international_navigation_energetic',
                    'myc_sector_final_consumption_of_geothermal_in_bunkers_international_navigation_energetic',
                    'myc_sector_final_consumption_of_renewable_waste_in_bunkers_international_navigation_energetic',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_bunkers_international_navigation_energetic',
                    'myc_sector_final_consumption_of_heat_in_bunkers_international_navigation_energetic',
                    'myc_sector_final_consumption_of_electricity_in_bunkers_international_navigation_energetic',
                    'myc_sector_final_consumption_of_hydrogen_in_bunkers_international_navigation_energetic',
                    'myc_sector_final_consumption_of_ammonia_in_bunkers_international_navigation_energetic',
                    'myc_sector_final_consumption_of_methanol_in_bunkers_international_navigation_energetic',
                  ],
                },
              ],
            },
            {
              key: 'fec_energetic_sector_industry_ex_ict_and_refineries',
              slug: 'industry-ex-ict-and-refineries',
              children: [
                {
                  key: 'fec_energetic_sector_industry_all',
                  slug: 'all',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_industry_ex_ict_and_refineries_energetic',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_industry_ex_ict_and_refineries_energetic',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_industry_ex_ict_and_refineries_energetic',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_industry_ex_ict_and_refineries_energetic',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_industry_ex_ict_and_refineries_energetic',
                    'myc_sector_final_consumption_of_solid_biofuels_in_industry_ex_ict_and_refineries_energetic',
                    'myc_sector_final_consumption_of_solar_thermal_in_industry_ex_ict_and_refineries_energetic',
                    'myc_sector_final_consumption_of_geothermal_in_industry_ex_ict_and_refineries_energetic',
                    'myc_sector_final_consumption_of_renewable_waste_in_industry_ex_ict_and_refineries_energetic',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_industry_ex_ict_and_refineries_energetic',
                    'myc_sector_final_consumption_of_heat_in_industry_ex_ict_and_refineries_energetic',
                    'myc_sector_final_consumption_of_electricity_in_industry_ex_ict_and_refineries_energetic',
                    'myc_sector_final_consumption_of_hydrogen_in_industry_ex_ict_and_refineries_energetic',
                    'myc_sector_final_consumption_of_ammonia_in_industry_ex_ict_and_refineries_energetic',
                    'myc_sector_final_consumption_of_methanol_in_industry_ex_ict_and_refineries_energetic',
                  ],
                },
                {
                  key: 'fec_energetic_sector_industry_aluminium',
                  slug: 'aluminium',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_industry_aluminium_energetic',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_industry_aluminium_energetic',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_industry_aluminium_energetic',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_industry_aluminium_energetic',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_industry_aluminium_energetic',
                    'myc_sector_final_consumption_of_solid_biofuels_in_industry_aluminium_energetic',
                    'myc_sector_final_consumption_of_solar_thermal_in_industry_aluminium_energetic',
                    'myc_sector_final_consumption_of_geothermal_in_industry_aluminium_energetic',
                    'myc_sector_final_consumption_of_renewable_waste_in_industry_aluminium_energetic',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_industry_aluminium_energetic',
                    'myc_sector_final_consumption_of_heat_in_industry_aluminium_energetic',
                    'myc_sector_final_consumption_of_electricity_in_industry_aluminium_energetic',
                    'myc_sector_final_consumption_of_hydrogen_in_industry_aluminium_energetic',
                    'myc_sector_final_consumption_of_ammonia_in_industry_aluminium_energetic',
                    'myc_sector_final_consumption_of_methanol_in_industry_aluminium_energetic',
                  ],
                },
                {
                  key: 'fec_energetic_sector_industry_steel',
                  slug: 'steel',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_industry_steel_energetic',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_industry_steel_energetic',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_industry_steel_energetic',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_industry_steel_energetic',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_industry_steel_energetic',
                    'myc_sector_final_consumption_of_solid_biofuels_in_industry_steel_energetic',
                    'myc_sector_final_consumption_of_solar_thermal_in_industry_steel_energetic',
                    'myc_sector_final_consumption_of_geothermal_in_industry_steel_energetic',
                    'myc_sector_final_consumption_of_renewable_waste_in_industry_steel_energetic',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_industry_steel_energetic',
                    'myc_sector_final_consumption_of_heat_in_industry_steel_energetic',
                    'myc_sector_final_consumption_of_electricity_in_industry_steel_energetic',
                    'myc_sector_final_consumption_of_hydrogen_in_industry_steel_energetic',
                    'myc_sector_final_consumption_of_ammonia_in_industry_steel_energetic',
                    'myc_sector_final_consumption_of_methanol_in_industry_steel_energetic',
                  ],
                },
                {
                  key: 'fec_energetic_sector_industry_other_metals',
                  slug: 'other-metals',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_industry_other_metals_energetic',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_industry_other_metals_energetic',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_industry_other_metals_energetic',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_industry_other_metals_energetic',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_industry_other_metals_energetic',
                    'myc_sector_final_consumption_of_solid_biofuels_in_industry_other_metals_energetic',
                    'myc_sector_final_consumption_of_solar_thermal_in_industry_other_metals_energetic',
                    'myc_sector_final_consumption_of_geothermal_in_industry_other_metals_energetic',
                    'myc_sector_final_consumption_of_renewable_waste_in_industry_other_metals_energetic',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_industry_other_metals_energetic',
                    'myc_sector_final_consumption_of_heat_in_industry_other_metals_energetic',
                    'myc_sector_final_consumption_of_electricity_in_industry_other_metals_energetic',
                    'myc_sector_final_consumption_of_hydrogen_in_industry_other_metals_energetic',
                    'myc_sector_final_consumption_of_ammonia_in_industry_other_metals_energetic',
                    'myc_sector_final_consumption_of_methanol_in_industry_other_metals_energetic',
                  ],
                },
                {
                  key: 'fec_energetic_sector_industry_other_chemical',
                  slug: 'other-chemical',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_industry_other_chemical_energetic',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_industry_other_chemical_energetic',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_industry_other_chemical_energetic',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_industry_other_chemical_energetic',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_industry_other_chemical_energetic',
                    'myc_sector_final_consumption_of_solid_biofuels_in_industry_other_chemical_energetic',
                    'myc_sector_final_consumption_of_solar_thermal_in_industry_other_chemical_energetic',
                    'myc_sector_final_consumption_of_geothermal_in_industry_other_chemical_energetic',
                    'myc_sector_final_consumption_of_renewable_waste_in_industry_other_chemical_energetic',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_industry_other_chemical_energetic',
                    'myc_sector_final_consumption_of_heat_in_industry_other_chemical_energetic',
                    'myc_sector_final_consumption_of_electricity_in_industry_other_chemical_energetic',
                    'myc_sector_final_consumption_of_hydrogen_in_industry_other_chemical_energetic',
                    'myc_sector_final_consumption_of_ammonia_in_industry_other_chemical_energetic',
                    'myc_sector_final_consumption_of_methanol_in_industry_other_chemical_energetic',
                  ],
                },
                {
                  key: 'fec_energetic_sector_industry_fertilizers',
                  slug: 'fertilizers',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_industry_fertilizers_energetic',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_industry_fertilizers_energetic',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_industry_fertilizers_energetic',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_industry_fertilizers_energetic',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_industry_fertilizers_energetic',
                    'myc_sector_final_consumption_of_solid_biofuels_in_industry_fertilizers_energetic',
                    'myc_sector_final_consumption_of_solar_thermal_in_industry_fertilizers_energetic',
                    'myc_sector_final_consumption_of_geothermal_in_industry_fertilizers_energetic',
                    'myc_sector_final_consumption_of_renewable_waste_in_industry_fertilizers_energetic',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_industry_fertilizers_energetic',
                    'myc_sector_final_consumption_of_heat_in_industry_fertilizers_energetic',
                    'myc_sector_final_consumption_of_electricity_in_industry_fertilizers_energetic',
                    'myc_sector_final_consumption_of_hydrogen_in_industry_fertilizers_energetic',
                    'myc_sector_final_consumption_of_ammonia_in_industry_fertilizers_energetic',
                    'myc_sector_final_consumption_of_methanol_in_industry_fertilizers_energetic',
                  ],
                },
                {
                  key: 'fec_energetic_sector_industry_paper',
                  slug: 'paper',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_industry_paper_energetic',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_industry_paper_energetic',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_industry_paper_energetic',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_industry_paper_energetic',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_industry_paper_energetic',
                    'myc_sector_final_consumption_of_solid_biofuels_in_industry_paper_energetic',
                    'myc_sector_final_consumption_of_solar_thermal_in_industry_paper_energetic',
                    'myc_sector_final_consumption_of_geothermal_in_industry_paper_energetic',
                    'myc_sector_final_consumption_of_renewable_waste_in_industry_paper_energetic',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_industry_paper_energetic',
                    'myc_sector_final_consumption_of_heat_in_industry_paper_energetic',
                    'myc_sector_final_consumption_of_electricity_in_industry_paper_energetic',
                    'myc_sector_final_consumption_of_hydrogen_in_industry_paper_energetic',
                    'myc_sector_final_consumption_of_ammonia_in_industry_paper_energetic',
                    'myc_sector_final_consumption_of_methanol_in_industry_paper_energetic',
                  ],
                },
                {
                  key: 'fec_energetic_sector_industry_food',
                  slug: 'food',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_industry_food_energetic',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_industry_food_energetic',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_industry_food_energetic',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_industry_food_energetic',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_industry_food_energetic',
                    'myc_sector_final_consumption_of_solid_biofuels_in_industry_food_energetic',
                    'myc_sector_final_consumption_of_solar_thermal_in_industry_food_energetic',
                    'myc_sector_final_consumption_of_geothermal_in_industry_food_energetic',
                    'myc_sector_final_consumption_of_renewable_waste_in_industry_food_energetic',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_industry_food_energetic',
                    'myc_sector_final_consumption_of_heat_in_industry_food_energetic',
                    'myc_sector_final_consumption_of_electricity_in_industry_food_energetic',
                    'myc_sector_final_consumption_of_hydrogen_in_industry_food_energetic',
                    'myc_sector_final_consumption_of_ammonia_in_industry_food_energetic',
                    'myc_sector_final_consumption_of_methanol_in_industry_food_energetic',
                  ],
                },
                {
                  key: 'fec_energetic_sector_industry_other_non_specified',
                  slug: 'other-non-specified',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_industry_other_non_specified_energetic',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_industry_other_non_specified_energetic',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_industry_other_non_specified_energetic',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_industry_other_non_specified_energetic',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_industry_other_non_specified_energetic',
                    'myc_sector_final_consumption_of_solid_biofuels_in_industry_other_non_specified_energetic',
                    'myc_sector_final_consumption_of_solar_thermal_in_industry_other_non_specified_energetic',
                    'myc_sector_final_consumption_of_geothermal_in_industry_other_non_specified_energetic',
                    'myc_sector_final_consumption_of_renewable_waste_in_industry_other_non_specified_energetic',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_industry_other_non_specified_energetic',
                    'myc_sector_final_consumption_of_heat_in_industry_other_non_specified_energetic',
                    'myc_sector_final_consumption_of_electricity_in_industry_other_non_specified_energetic',
                    'myc_sector_final_consumption_of_hydrogen_in_industry_other_non_specified_energetic',
                    'myc_sector_final_consumption_of_ammonia_in_industry_other_non_specified_energetic',
                    'myc_sector_final_consumption_of_methanol_in_industry_other_non_specified_energetic',
                  ],
                },
              ],
            },
            {
              key: 'fec_energetic_sector_industry_ict',
              slug: 'industry-ict',
              series: [
                'myc_sector_final_consumption_of_coal_and_coal_products_in_industry_ict_energetic',
                'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_industry_ict_energetic',
                'myc_sector_final_consumption_of_oil_and_oil_products_in_industry_ict_energetic',
                'myc_sector_final_consumption_of_liquid_biofuels_in_industry_ict_energetic',
                'myc_sector_final_consumption_of_gaseous_biofuels_in_industry_ict_energetic',
                'myc_sector_final_consumption_of_solid_biofuels_in_industry_ict_energetic',
                'myc_sector_final_consumption_of_solar_thermal_in_industry_ict_energetic',
                'myc_sector_final_consumption_of_geothermal_in_industry_ict_energetic',
                'myc_sector_final_consumption_of_renewable_waste_in_industry_ict_energetic',
                'myc_sector_final_consumption_of_non_renewable_waste_in_industry_ict_energetic',
                'myc_sector_final_consumption_of_heat_in_industry_ict_energetic',
                'myc_sector_final_consumption_of_electricity_in_industry_ict_energetic',
                'myc_sector_final_consumption_of_hydrogen_in_industry_ict_energetic',
                'myc_sector_final_consumption_of_ammonia_in_industry_ict_energetic',
                'myc_sector_final_consumption_of_methanol_in_industry_ict_energetic',
              ],
            },
            {
              key: 'fec_energetic_sector_industry_refineries',
              slug: 'industry-refineries',
              series: [
                'myc_sector_final_consumption_of_coal_and_coal_products_in_industry_refineries_energetic',
                'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_industry_refineries_energetic',
                'myc_sector_final_consumption_of_oil_and_oil_products_in_industry_refineries_energetic',
                'myc_sector_final_consumption_of_liquid_biofuels_in_industry_refineries_energetic',
                'myc_sector_final_consumption_of_gaseous_biofuels_in_industry_refineries_energetic',
                'myc_sector_final_consumption_of_solid_biofuels_in_industry_refineries_energetic',
                'myc_sector_final_consumption_of_solar_thermal_in_industry_refineries_energetic',
                'myc_sector_final_consumption_of_geothermal_in_industry_refineries_energetic',
                'myc_sector_final_consumption_of_renewable_waste_in_industry_refineries_energetic',
                'myc_sector_final_consumption_of_non_renewable_waste_in_industry_refineries_energetic',
                'myc_sector_final_consumption_of_heat_in_industry_refineries_energetic',
                'myc_sector_final_consumption_of_electricity_in_industry_refineries_energetic',
                'myc_sector_final_consumption_of_hydrogen_in_industry_refineries_energetic',
                'myc_sector_final_consumption_of_ammonia_in_industry_refineries_energetic',
                'myc_sector_final_consumption_of_methanol_in_industry_refineries_energetic',
              ],
            },
            {
              key: 'fec_energetic_sector_agriculture',
              slug: 'agriculture',
              series: [
                'myc_sector_final_consumption_of_coal_and_coal_products_in_agriculture_energetic',
                'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_agriculture_energetic',
                'myc_sector_final_consumption_of_oil_and_oil_products_in_agriculture_energetic',
                'myc_sector_final_consumption_of_liquid_biofuels_in_agriculture_energetic',
                'myc_sector_final_consumption_of_gaseous_biofuels_in_agriculture_energetic',
                'myc_sector_final_consumption_of_solid_biofuels_in_agriculture_energetic',
                'myc_sector_final_consumption_of_solar_thermal_in_agriculture_energetic',
                'myc_sector_final_consumption_of_geothermal_in_agriculture_energetic',
                'myc_sector_final_consumption_of_renewable_waste_in_agriculture_energetic',
                'myc_sector_final_consumption_of_non_renewable_waste_in_agriculture_energetic',
                'myc_sector_final_consumption_of_heat_in_agriculture_energetic',
                'myc_sector_final_consumption_of_electricity_in_agriculture_energetic',
                'myc_sector_final_consumption_of_hydrogen_in_agriculture_energetic',
                'myc_sector_final_consumption_of_ammonia_in_agriculture_energetic',
                'myc_sector_final_consumption_of_methanol_in_agriculture_energetic',
              ],
            },
            {
              key: 'fec_energetic_sector_energy',
              slug: 'energy',
              series: [
                'myc_sector_final_consumption_of_coal_and_coal_products_in_energy_energetic',
                'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_energy_energetic',
                'myc_sector_final_consumption_of_oil_and_oil_products_in_energy_energetic',
                'myc_sector_final_consumption_of_liquid_biofuels_in_energy_energetic',
                'myc_sector_final_consumption_of_gaseous_biofuels_in_energy_energetic',
                'myc_sector_final_consumption_of_solid_biofuels_in_energy_energetic',
                'myc_sector_final_consumption_of_solar_thermal_in_energy_energetic',
                'myc_sector_final_consumption_of_geothermal_in_energy_energetic',
                'myc_sector_final_consumption_of_renewable_waste_in_energy_energetic',
                'myc_sector_final_consumption_of_non_renewable_waste_in_energy_energetic',
                'myc_sector_final_consumption_of_heat_in_energy_energetic',
                'myc_sector_final_consumption_of_electricity_in_energy_energetic',
                'myc_sector_final_consumption_of_hydrogen_in_energy_energetic',
                'myc_sector_final_consumption_of_ammonia_in_energy_energetic',
                'myc_sector_final_consumption_of_methanol_in_energy_energetic',
              ],
            },
            {
              key: 'fec_energetic_sector_other',
              slug: 'other',
              series: [
                'myc_sector_final_consumption_of_coal_and_coal_products_in_other_energetic',
                'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_other_energetic',
                'myc_sector_final_consumption_of_oil_and_oil_products_in_other_energetic',
                'myc_sector_final_consumption_of_liquid_biofuels_in_other_energetic',
                'myc_sector_final_consumption_of_gaseous_biofuels_in_other_energetic',
                'myc_sector_final_consumption_of_solid_biofuels_in_other_energetic',
                'myc_sector_final_consumption_of_solar_thermal_in_other_energetic',
                'myc_sector_final_consumption_of_geothermal_in_other_energetic',
                'myc_sector_final_consumption_of_renewable_waste_in_other_energetic',
                'myc_sector_final_consumption_of_non_renewable_waste_in_other_energetic',
                'myc_sector_final_consumption_of_heat_in_other_energetic',
                'myc_sector_final_consumption_of_electricity_in_other_energetic',
                'myc_sector_final_consumption_of_hydrogen_in_other_energetic',
                'myc_sector_final_consumption_of_ammonia_in_other_energetic',
                'myc_sector_final_consumption_of_methanol_in_other_energetic',
              ],
            },
          ],
        },
        {
          key: 'fec_energetic_per_carrier',
          slug: 'per-carrier',
          children: [
            {
              key: 'fec_energetic_carrier_all',
              slug: 'all',
              series: [
                'myc_carrier_final_consumption_of_coal_and_coal_products_energetic',
                'myc_carrier_final_consumption_of_natural_gas_and_gas_products_energetic',
                'myc_carrier_final_consumption_of_oil_and_oil_products_energetic',
                'myc_carrier_final_consumption_of_liquid_biofuels_energetic',
                'myc_carrier_final_consumption_of_gaseous_biofuels_energetic',
                'myc_carrier_final_consumption_of_solid_biofuels_energetic',
                'myc_carrier_final_consumption_of_solar_thermal_energetic',
                'myc_carrier_final_consumption_of_geothermal_energetic',
                'myc_carrier_final_consumption_of_renewable_waste_energetic',
                'myc_carrier_final_consumption_of_non_renewable_waste_energetic',
                'myc_carrier_final_consumption_of_heat_energetic',
                'myc_carrier_final_consumption_of_electricity_energetic',
                'myc_carrier_final_consumption_of_hydrogen_energetic',
                'myc_carrier_final_consumption_of_ammonia_energetic',
                'myc_carrier_final_consumption_of_methanol_energetic',
              ],
            },
            {
              key: 'fec_energetic_carrier_coal_and_coal_products',
              slug: 'coal-and-coal-products',
              series: [
                'myc_carrier_final_consumption_of_coal_and_coal_products_in_households_energetic',
                'myc_carrier_final_consumption_of_coal_and_coal_products_in_buildings_energetic',
                'myc_carrier_final_consumption_of_coal_and_coal_products_in_national_transport_energetic',
                'myc_carrier_final_consumption_of_coal_and_coal_products_in_international_transport_energetic',
                'myc_carrier_final_consumption_of_coal_and_coal_products_in_industry_ex_ict_and_refineries_energetic',
                'myc_carrier_final_consumption_of_coal_and_coal_products_in_industry_ict_energetic',
                'myc_carrier_final_consumption_of_coal_and_coal_products_in_industry_refineries_energetic',
                'myc_carrier_final_consumption_of_coal_and_coal_products_in_agriculture_energetic',
                'myc_carrier_final_consumption_of_coal_and_coal_products_in_energy_energetic',
                'myc_carrier_final_consumption_of_coal_and_coal_products_in_other_energetic',
              ],
            },
            {
              key: 'fec_energetic_carrier_natural_gas_and_gas_products',
              slug: 'natural-gas-and-gas-products',
              series: [
                'myc_carrier_final_consumption_of_natural_gas_and_gas_products_in_households_energetic',
                'myc_carrier_final_consumption_of_natural_gas_and_gas_products_in_buildings_energetic',
                'myc_carrier_final_consumption_of_natural_gas_and_gas_products_in_national_transport_energetic',
                'myc_carrier_final_consumption_of_natural_gas_and_gas_products_in_international_transport_energetic',
                'myc_carrier_final_consumption_of_natural_gas_and_gas_products_in_industry_ex_ict_and_refineries_energetic',
                'myc_carrier_final_consumption_of_natural_gas_and_gas_products_in_industry_ict_energetic',
                'myc_carrier_final_consumption_of_natural_gas_and_gas_products_in_industry_refineries_energetic',
                'myc_carrier_final_consumption_of_natural_gas_and_gas_products_in_agriculture_energetic',
                'myc_carrier_final_consumption_of_natural_gas_and_gas_products_in_energy_energetic',
                'myc_carrier_final_consumption_of_natural_gas_and_gas_products_in_other_energetic',
              ],
            },
            {
              key: 'fec_energetic_carrier_oil_and_oil_products',
              slug: 'oil-and-oil-products',
              series: [
                'myc_carrier_final_consumption_of_oil_and_oil_products_in_households_energetic',
                'myc_carrier_final_consumption_of_oil_and_oil_products_in_buildings_energetic',
                'myc_carrier_final_consumption_of_oil_and_oil_products_in_national_transport_energetic',
                'myc_carrier_final_consumption_of_oil_and_oil_products_in_international_transport_energetic',
                'myc_carrier_final_consumption_of_oil_and_oil_products_in_industry_ex_ict_and_refineries_energetic',
                'myc_carrier_final_consumption_of_oil_and_oil_products_in_industry_ict_energetic',
                'myc_carrier_final_consumption_of_oil_and_oil_products_in_industry_refineries_energetic',
                'myc_carrier_final_consumption_of_oil_and_oil_products_in_agriculture_energetic',
                'myc_carrier_final_consumption_of_oil_and_oil_products_in_energy_energetic',
                'myc_carrier_final_consumption_of_oil_and_oil_products_in_other_energetic',
              ],
            },
            {
              key: 'fec_energetic_carrier_liquid_biofuels',
              slug: 'liquid-biofuels',
              series: [
                'myc_carrier_final_consumption_of_liquid_biofuels_in_households_energetic',
                'myc_carrier_final_consumption_of_liquid_biofuels_in_buildings_energetic',
                'myc_carrier_final_consumption_of_liquid_biofuels_in_national_transport_energetic',
                'myc_carrier_final_consumption_of_liquid_biofuels_in_international_transport_energetic',
                'myc_carrier_final_consumption_of_liquid_biofuels_in_industry_ex_ict_and_refineries_energetic',
                'myc_carrier_final_consumption_of_liquid_biofuels_in_industry_ict_energetic',
                'myc_carrier_final_consumption_of_liquid_biofuels_in_industry_refineries_energetic',
                'myc_carrier_final_consumption_of_liquid_biofuels_in_agriculture_energetic',
                'myc_carrier_final_consumption_of_liquid_biofuels_in_energy_energetic',
                'myc_carrier_final_consumption_of_liquid_biofuels_in_other_energetic',
              ],
            },
            {
              key: 'fec_energetic_carrier_gaseous_biofuels',
              slug: 'gaseous-biofuels',
              series: [
                'myc_carrier_final_consumption_of_gaseous_biofuels_in_households_energetic',
                'myc_carrier_final_consumption_of_gaseous_biofuels_in_buildings_energetic',
                'myc_carrier_final_consumption_of_gaseous_biofuels_in_national_transport_energetic',
                'myc_carrier_final_consumption_of_gaseous_biofuels_in_international_transport_energetic',
                'myc_carrier_final_consumption_of_gaseous_biofuels_in_industry_ex_ict_and_refineries_energetic',
                'myc_carrier_final_consumption_of_gaseous_biofuels_in_industry_ict_energetic',
                'myc_carrier_final_consumption_of_gaseous_biofuels_in_industry_refineries_energetic',
                'myc_carrier_final_consumption_of_gaseous_biofuels_in_agriculture_energetic',
                'myc_carrier_final_consumption_of_gaseous_biofuels_in_energy_energetic',
                'myc_carrier_final_consumption_of_gaseous_biofuels_in_other_energetic',
              ],
            },
            {
              key: 'fec_energetic_carrier_solid_biofuels',
              slug: 'solid-biofuels',
              series: [
                'myc_carrier_final_consumption_of_solid_biofuels_in_households_energetic',
                'myc_carrier_final_consumption_of_solid_biofuels_in_buildings_energetic',
                'myc_carrier_final_consumption_of_solid_biofuels_in_national_transport_energetic',
                'myc_carrier_final_consumption_of_solid_biofuels_in_international_transport_energetic',
                'myc_carrier_final_consumption_of_solid_biofuels_in_industry_ex_ict_and_refineries_energetic',
                'myc_carrier_final_consumption_of_solid_biofuels_in_industry_ict_energetic',
                'myc_carrier_final_consumption_of_solid_biofuels_in_industry_refineries_energetic',
                'myc_carrier_final_consumption_of_solid_biofuels_in_agriculture_energetic',
                'myc_carrier_final_consumption_of_solid_biofuels_in_energy_energetic',
                'myc_carrier_final_consumption_of_solid_biofuels_in_other_energetic',
              ],
            },
            {
              key: 'fec_energetic_carrier_solar_thermal',
              slug: 'solar-thermal',
              series: [
                'myc_carrier_final_consumption_of_solar_thermal_in_households_energetic',
                'myc_carrier_final_consumption_of_solar_thermal_in_buildings_energetic',
                'myc_carrier_final_consumption_of_solar_thermal_in_national_transport_energetic',
                'myc_carrier_final_consumption_of_solar_thermal_in_international_transport_energetic',
                'myc_carrier_final_consumption_of_solar_thermal_in_industry_ex_ict_and_refineries_energetic',
                'myc_carrier_final_consumption_of_solar_thermal_in_industry_ict_energetic',
                'myc_carrier_final_consumption_of_solar_thermal_in_industry_refineries_energetic',
                'myc_carrier_final_consumption_of_solar_thermal_in_agriculture_energetic',
                'myc_carrier_final_consumption_of_solar_thermal_in_energy_energetic',
                'myc_carrier_final_consumption_of_solar_thermal_in_other_energetic',
              ],
            },
            {
              key: 'fec_energetic_carrier_geothermal',
              slug: 'geothermal',
              series: [
                'myc_carrier_final_consumption_of_geothermal_in_households_energetic',
                'myc_carrier_final_consumption_of_geothermal_in_buildings_energetic',
                'myc_carrier_final_consumption_of_geothermal_in_national_transport_energetic',
                'myc_carrier_final_consumption_of_geothermal_in_international_transport_energetic',
                'myc_carrier_final_consumption_of_geothermal_in_industry_ex_ict_and_refineries_energetic',
                'myc_carrier_final_consumption_of_geothermal_in_industry_ict_energetic',
                'myc_carrier_final_consumption_of_geothermal_in_industry_refineries_energetic',
                'myc_carrier_final_consumption_of_geothermal_in_agriculture_energetic',
                'myc_carrier_final_consumption_of_geothermal_in_energy_energetic',
                'myc_carrier_final_consumption_of_geothermal_in_other_energetic',
              ],
            },
            {
              key: 'fec_energetic_carrier_renewable_waste',
              slug: 'renewable-waste',
              series: [
                'myc_carrier_final_consumption_of_renewable_waste_in_households_energetic',
                'myc_carrier_final_consumption_of_renewable_waste_in_buildings_energetic',
                'myc_carrier_final_consumption_of_renewable_waste_in_national_transport_energetic',
                'myc_carrier_final_consumption_of_renewable_waste_in_international_transport_energetic',
                'myc_carrier_final_consumption_of_renewable_waste_in_industry_ex_ict_and_refineries_energetic',
                'myc_carrier_final_consumption_of_renewable_waste_in_industry_ict_energetic',
                'myc_carrier_final_consumption_of_renewable_waste_in_industry_refineries_energetic',
                'myc_carrier_final_consumption_of_renewable_waste_in_agriculture_energetic',
                'myc_carrier_final_consumption_of_renewable_waste_in_energy_energetic',
                'myc_carrier_final_consumption_of_renewable_waste_in_other_energetic',
              ],
            },
            {
              key: 'fec_energetic_carrier_non_renewable_waste',
              slug: 'non-renewable-waste',
              series: [
                'myc_carrier_final_consumption_of_non_renewable_waste_in_households_energetic',
                'myc_carrier_final_consumption_of_non_renewable_waste_in_buildings_energetic',
                'myc_carrier_final_consumption_of_non_renewable_waste_in_national_transport_energetic',
                'myc_carrier_final_consumption_of_non_renewable_waste_in_international_transport_energetic',
                'myc_carrier_final_consumption_of_non_renewable_waste_in_industry_ex_ict_and_refineries_energetic',
                'myc_carrier_final_consumption_of_non_renewable_waste_in_industry_ict_energetic',
                'myc_carrier_final_consumption_of_non_renewable_waste_in_industry_refineries_energetic',
                'myc_carrier_final_consumption_of_non_renewable_waste_in_agriculture_energetic',
                'myc_carrier_final_consumption_of_non_renewable_waste_in_energy_energetic',
                'myc_carrier_final_consumption_of_non_renewable_waste_in_other_energetic',
              ],
            },
            {
              key: 'fec_energetic_carrier_heat',
              slug: 'heat',
              series: [
                'myc_carrier_final_consumption_of_heat_in_households_energetic',
                'myc_carrier_final_consumption_of_heat_in_buildings_energetic',
                'myc_carrier_final_consumption_of_heat_in_national_transport_energetic',
                'myc_carrier_final_consumption_of_heat_in_international_transport_energetic',
                'myc_carrier_final_consumption_of_heat_in_industry_ex_ict_and_refineries_energetic',
                'myc_carrier_final_consumption_of_heat_in_industry_ict_energetic',
                'myc_carrier_final_consumption_of_heat_in_industry_refineries_energetic',
                'myc_carrier_final_consumption_of_heat_in_agriculture_energetic',
                'myc_carrier_final_consumption_of_heat_in_energy_energetic',
                'myc_carrier_final_consumption_of_heat_in_other_energetic',
              ],
            },
            {
              key: 'fec_energetic_carrier_electricity',
              slug: 'electricity',
              series: [
                'myc_carrier_final_consumption_of_electricity_in_households_energetic',
                'myc_carrier_final_consumption_of_electricity_in_buildings_energetic',
                'myc_carrier_final_consumption_of_electricity_in_national_transport_energetic',
                'myc_carrier_final_consumption_of_electricity_in_international_transport_energetic',
                'myc_carrier_final_consumption_of_electricity_in_industry_ex_ict_and_refineries_energetic',
                'myc_carrier_final_consumption_of_electricity_in_industry_ict_energetic',
                'myc_carrier_final_consumption_of_electricity_in_industry_refineries_energetic',
                'myc_carrier_final_consumption_of_electricity_in_agriculture_energetic',
                'myc_carrier_final_consumption_of_electricity_in_energy_energetic',
                'myc_carrier_final_consumption_of_electricity_in_other_energetic',
              ],
            },
            {
              key: 'fec_energetic_carrier_hydrogen',
              slug: 'hydrogen',
              series: [
                'myc_carrier_final_consumption_of_hydrogen_in_households_energetic',
                'myc_carrier_final_consumption_of_hydrogen_in_buildings_energetic',
                'myc_carrier_final_consumption_of_hydrogen_in_national_transport_energetic',
                'myc_carrier_final_consumption_of_hydrogen_in_international_transport_energetic',
                'myc_carrier_final_consumption_of_hydrogen_in_industry_ex_ict_and_refineries_energetic',
                'myc_carrier_final_consumption_of_hydrogen_in_industry_ict_energetic',
                'myc_carrier_final_consumption_of_hydrogen_in_industry_refineries_energetic',
                'myc_carrier_final_consumption_of_hydrogen_in_agriculture_energetic',
                'myc_carrier_final_consumption_of_hydrogen_in_energy_energetic',
                'myc_carrier_final_consumption_of_hydrogen_in_other_energetic',
              ],
            },
            {
              key: 'fec_energetic_carrier_ammonia',
              slug: 'ammonia',
              series: [
                'myc_carrier_final_consumption_of_ammonia_in_households_energetic',
                'myc_carrier_final_consumption_of_ammonia_in_buildings_energetic',
                'myc_carrier_final_consumption_of_ammonia_in_national_transport_energetic',
                'myc_carrier_final_consumption_of_ammonia_in_international_transport_energetic',
                'myc_carrier_final_consumption_of_ammonia_in_industry_ex_ict_and_refineries_energetic',
                'myc_carrier_final_consumption_of_ammonia_in_industry_ict_energetic',
                'myc_carrier_final_consumption_of_ammonia_in_industry_refineries_energetic',
                'myc_carrier_final_consumption_of_ammonia_in_agriculture_energetic',
                'myc_carrier_final_consumption_of_ammonia_in_energy_energetic',
                'myc_carrier_final_consumption_of_ammonia_in_other_energetic',
              ],
            },
            {
              key: 'fec_energetic_carrier_methanol',
              slug: 'methanol',
              series: [
                'myc_carrier_final_consumption_of_methanol_in_households_energetic',
                'myc_carrier_final_consumption_of_methanol_in_buildings_energetic',
                'myc_carrier_final_consumption_of_methanol_in_national_transport_energetic',
                'myc_carrier_final_consumption_of_methanol_in_international_transport_energetic',
                'myc_carrier_final_consumption_of_methanol_in_industry_ex_ict_and_refineries_energetic',
                'myc_carrier_final_consumption_of_methanol_in_industry_ict_energetic',
                'myc_carrier_final_consumption_of_methanol_in_industry_refineries_energetic',
                'myc_carrier_final_consumption_of_methanol_in_agriculture_energetic',
                'myc_carrier_final_consumption_of_methanol_in_energy_energetic',
                'myc_carrier_final_consumption_of_methanol_in_other_energetic',
              ],
            },
          ],
        },
      ],
    },
    {
      key: 'fec_non_energetic',
      slug: 'non-energetic',
      children: [
        {
          key: 'fec_non_energetic_per_sector',
          slug: 'per-sector',
          children: [
            {
              key: 'fec_non_energetic_sector_all',
              slug: 'all',
              series: [
                'myc_sector_final_consumption_from_national_transport_non_energetic',
                'myc_sector_final_consumption_from_industry_ex_ict_and_refineries_non_energetic',
                'myc_sector_final_consumption_from_industry_refineries_non_energetic',
                'myc_sector_final_consumption_from_other_non_energetic',
              ],
            },
            {
              key: 'fec_non_energetic_sector_national_transport',
              slug: 'national-transport',
              series: [
                'myc_sector_final_consumption_of_coal_and_coal_products_in_national_transport_non_energetic',
                'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_national_transport_non_energetic',
                'myc_sector_final_consumption_of_oil_and_oil_products_in_national_transport_non_energetic',
                'myc_sector_final_consumption_of_liquid_biofuels_in_national_transport_non_energetic',
                'myc_sector_final_consumption_of_gaseous_biofuels_in_national_transport_non_energetic',
                'myc_sector_final_consumption_of_solid_biofuels_in_national_transport_non_energetic',
                'myc_sector_final_consumption_of_solar_thermal_in_national_transport_non_energetic',
                'myc_sector_final_consumption_of_geothermal_in_national_transport_non_energetic',
                'myc_sector_final_consumption_of_renewable_waste_in_national_transport_non_energetic',
                'myc_sector_final_consumption_of_non_renewable_waste_in_national_transport_non_energetic',
                'myc_sector_final_consumption_of_heat_in_national_transport_non_energetic',
                'myc_sector_final_consumption_of_electricity_in_national_transport_non_energetic',
                'myc_sector_final_consumption_of_hydrogen_in_national_transport_non_energetic',
                'myc_sector_final_consumption_of_ammonia_in_national_transport_non_energetic',
                'myc_sector_final_consumption_of_methanol_in_national_transport_non_energetic',
              ],
            },
            {
              key: 'fec_non_energetic_sector_industry_ex_ict_and_refineries',
              slug: 'industry-ex-ict-and-refineries',
              children: [
                {
                  key: 'fec_non_energetic_sector_industry_all',
                  slug: 'all',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_industry_ex_ict_and_refineries_non_energetic',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_industry_ex_ict_and_refineries_non_energetic',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_industry_ex_ict_and_refineries_non_energetic',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_industry_ex_ict_and_refineries_non_energetic',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_industry_ex_ict_and_refineries_non_energetic',
                    'myc_sector_final_consumption_of_solid_biofuels_in_industry_ex_ict_and_refineries_non_energetic',
                    'myc_sector_final_consumption_of_solar_thermal_in_industry_ex_ict_and_refineries_non_energetic',
                    'myc_sector_final_consumption_of_geothermal_in_industry_ex_ict_and_refineries_non_energetic',
                    'myc_sector_final_consumption_of_renewable_waste_in_industry_ex_ict_and_refineries_non_energetic',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_industry_ex_ict_and_refineries_non_energetic',
                    'myc_sector_final_consumption_of_heat_in_industry_ex_ict_and_refineries_non_energetic',
                    'myc_sector_final_consumption_of_electricity_in_industry_ex_ict_and_refineries_non_energetic',
                    'myc_sector_final_consumption_of_hydrogen_in_industry_ex_ict_and_refineries_non_energetic',
                    'myc_sector_final_consumption_of_ammonia_in_industry_ex_ict_and_refineries_non_energetic',
                    'myc_sector_final_consumption_of_methanol_in_industry_ex_ict_and_refineries_non_energetic',
                  ],
                },
                {
                  key: 'fec_non_energetic_sector_industry_other_chemical',
                  slug: 'other-chemical',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_industry_other_chemical_non_energetic',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_industry_other_chemical_non_energetic',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_industry_other_chemical_non_energetic',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_industry_other_chemical_non_energetic',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_industry_other_chemical_non_energetic',
                    'myc_sector_final_consumption_of_solid_biofuels_in_industry_other_chemical_non_energetic',
                    'myc_sector_final_consumption_of_solar_thermal_in_industry_other_chemical_non_energetic',
                    'myc_sector_final_consumption_of_geothermal_in_industry_other_chemical_non_energetic',
                    'myc_sector_final_consumption_of_renewable_waste_in_industry_other_chemical_non_energetic',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_industry_other_chemical_non_energetic',
                    'myc_sector_final_consumption_of_heat_in_industry_other_chemical_non_energetic',
                    'myc_sector_final_consumption_of_electricity_in_industry_other_chemical_non_energetic',
                    'myc_sector_final_consumption_of_hydrogen_in_industry_other_chemical_non_energetic',
                    'myc_sector_final_consumption_of_ammonia_in_industry_other_chemical_non_energetic',
                    'myc_sector_final_consumption_of_methanol_in_industry_other_chemical_non_energetic',
                  ],
                },
                {
                  key: 'fec_non_energetic_sector_industry_fertilizers',
                  slug: 'fertilizers',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_industry_fertilizers_non_energetic',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_industry_fertilizers_non_energetic',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_industry_fertilizers_non_energetic',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_industry_fertilizers_non_energetic',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_industry_fertilizers_non_energetic',
                    'myc_sector_final_consumption_of_solid_biofuels_in_industry_fertilizers_non_energetic',
                    'myc_sector_final_consumption_of_solar_thermal_in_industry_fertilizers_non_energetic',
                    'myc_sector_final_consumption_of_geothermal_in_industry_fertilizers_non_energetic',
                    'myc_sector_final_consumption_of_renewable_waste_in_industry_fertilizers_non_energetic',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_industry_fertilizers_non_energetic',
                    'myc_sector_final_consumption_of_heat_in_industry_fertilizers_non_energetic',
                    'myc_sector_final_consumption_of_electricity_in_industry_fertilizers_non_energetic',
                    'myc_sector_final_consumption_of_hydrogen_in_industry_fertilizers_non_energetic',
                    'myc_sector_final_consumption_of_ammonia_in_industry_fertilizers_non_energetic',
                    'myc_sector_final_consumption_of_methanol_in_industry_fertilizers_non_energetic',
                  ],
                },
                {
                  key: 'fec_non_energetic_sector_industry_other_non_specified',
                  slug: 'other-non-specified',
                  series: [
                    'myc_sector_final_consumption_of_coal_and_coal_products_in_industry_other_non_specified_non_energetic',
                    'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_industry_other_non_specified_non_energetic',
                    'myc_sector_final_consumption_of_oil_and_oil_products_in_industry_other_non_specified_non_energetic',
                    'myc_sector_final_consumption_of_liquid_biofuels_in_industry_other_non_specified_non_energetic',
                    'myc_sector_final_consumption_of_gaseous_biofuels_in_industry_other_non_specified_non_energetic',
                    'myc_sector_final_consumption_of_solid_biofuels_in_industry_other_non_specified_non_energetic',
                    'myc_sector_final_consumption_of_solar_thermal_in_industry_other_non_specified_non_energetic',
                    'myc_sector_final_consumption_of_geothermal_in_industry_other_non_specified_non_energetic',
                    'myc_sector_final_consumption_of_renewable_waste_in_industry_other_non_specified_non_energetic',
                    'myc_sector_final_consumption_of_non_renewable_waste_in_industry_other_non_specified_non_energetic',
                    'myc_sector_final_consumption_of_heat_in_industry_other_non_specified_non_energetic',
                    'myc_sector_final_consumption_of_electricity_in_industry_other_non_specified_non_energetic',
                    'myc_sector_final_consumption_of_hydrogen_in_industry_other_non_specified_non_energetic',
                    'myc_sector_final_consumption_of_ammonia_in_industry_other_non_specified_non_energetic',
                    'myc_sector_final_consumption_of_methanol_in_industry_other_non_specified_non_energetic',
                  ],
                },
              ],
            },
            {
              key: 'fec_non_energetic_sector_industry_refineries',
              slug: 'industry-refineries',
              series: [
                'myc_sector_final_consumption_of_coal_and_coal_products_in_industry_refineries_non_energetic',
                'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_industry_refineries_non_energetic',
                'myc_sector_final_consumption_of_oil_and_oil_products_in_industry_refineries_non_energetic',
                'myc_sector_final_consumption_of_liquid_biofuels_in_industry_refineries_non_energetic',
                'myc_sector_final_consumption_of_gaseous_biofuels_in_industry_refineries_non_energetic',
                'myc_sector_final_consumption_of_solid_biofuels_in_industry_refineries_non_energetic',
                'myc_sector_final_consumption_of_solar_thermal_in_industry_refineries_non_energetic',
                'myc_sector_final_consumption_of_geothermal_in_industry_refineries_non_energetic',
                'myc_sector_final_consumption_of_renewable_waste_in_industry_refineries_non_energetic',
                'myc_sector_final_consumption_of_non_renewable_waste_in_industry_refineries_non_energetic',
                'myc_sector_final_consumption_of_heat_in_industry_refineries_non_energetic',
                'myc_sector_final_consumption_of_electricity_in_industry_refineries_non_energetic',
                'myc_sector_final_consumption_of_hydrogen_in_industry_refineries_non_energetic',
                'myc_sector_final_consumption_of_ammonia_in_industry_refineries_non_energetic',
                'myc_sector_final_consumption_of_methanol_in_industry_refineries_non_energetic',
              ],
            },
            {
              key: 'fec_non_energetic_sector_other',
              slug: 'other',
              series: [
                'myc_sector_final_consumption_of_coal_and_coal_products_in_other_non_energetic',
                'myc_sector_final_consumption_of_natural_gas_and_gas_products_in_other_non_energetic',
                'myc_sector_final_consumption_of_oil_and_oil_products_in_other_non_energetic',
                'myc_sector_final_consumption_of_liquid_biofuels_in_other_non_energetic',
                'myc_sector_final_consumption_of_gaseous_biofuels_in_other_non_energetic',
                'myc_sector_final_consumption_of_solid_biofuels_in_other_non_energetic',
                'myc_sector_final_consumption_of_solar_thermal_in_other_non_energetic',
                'myc_sector_final_consumption_of_geothermal_in_other_non_energetic',
                'myc_sector_final_consumption_of_renewable_waste_in_other_non_energetic',
                'myc_sector_final_consumption_of_non_renewable_waste_in_other_non_energetic',
                'myc_sector_final_consumption_of_heat_in_other_non_energetic',
                'myc_sector_final_consumption_of_electricity_in_other_non_energetic',
                'myc_sector_final_consumption_of_hydrogen_in_other_non_energetic',
                'myc_sector_final_consumption_of_ammonia_in_other_non_energetic',
                'myc_sector_final_consumption_of_methanol_in_other_non_energetic',
              ],
            },
          ],
        },
        {
          key: 'fec_non_energetic_per_carrier',
          slug: 'per-carrier',
          children: [
            {
              key: 'fec_non_energetic_carrier_all',
              slug: 'all',
              series: [
                'myc_carrier_final_consumption_of_coal_and_coal_products_non_energetic',
                'myc_carrier_final_consumption_of_natural_gas_and_gas_products_non_energetic',
                'myc_carrier_final_consumption_of_oil_and_oil_products_non_energetic',
                'myc_carrier_final_consumption_of_liquid_biofuels_non_energetic',
                'myc_carrier_final_consumption_of_gaseous_biofuels_non_energetic',
                'myc_carrier_final_consumption_of_solid_biofuels_non_energetic',
                'myc_carrier_final_consumption_of_solar_thermal_non_energetic',
                'myc_carrier_final_consumption_of_geothermal_non_energetic',
                'myc_carrier_final_consumption_of_renewable_waste_non_energetic',
                'myc_carrier_final_consumption_of_non_renewable_waste_non_energetic',
                'myc_carrier_final_consumption_of_heat_non_energetic',
                'myc_carrier_final_consumption_of_electricity_non_energetic',
                'myc_carrier_final_consumption_of_hydrogen_non_energetic',
                'myc_carrier_final_consumption_of_ammonia_non_energetic',
                'myc_carrier_final_consumption_of_methanol_non_energetic',
              ],
            },
            {
              key: 'fec_non_energetic_carrier_coal_and_coal_products',
              slug: 'coal-and-coal-products',
              series: [
                'myc_carrier_final_consumption_of_coal_and_coal_products_in_national_transport_non_energetic',
                'myc_carrier_final_consumption_of_coal_and_coal_products_in_industry_ex_ict_and_refineries_non_energetic',
                'myc_carrier_final_consumption_of_coal_and_coal_products_in_industry_refineries_non_energetic',
                'myc_carrier_final_consumption_of_coal_and_coal_products_in_other_non_energetic',
              ],
            },
            {
              key: 'fec_non_energetic_carrier_natural_gas_and_gas_products',
              slug: 'natural-gas-and-gas-products',
              series: [
                'myc_carrier_final_consumption_of_natural_gas_and_gas_products_in_national_transport_non_energetic',
                'myc_carrier_final_consumption_of_natural_gas_and_gas_products_in_industry_ex_ict_and_refineries_non_energetic',
                'myc_carrier_final_consumption_of_natural_gas_and_gas_products_in_industry_refineries_non_energetic',
                'myc_carrier_final_consumption_of_natural_gas_and_gas_products_in_other_non_energetic',
              ],
            },
            {
              key: 'fec_non_energetic_carrier_oil_and_oil_products',
              slug: 'oil-and-oil-products',
              series: [
                'myc_carrier_final_consumption_of_oil_and_oil_products_in_national_transport_non_energetic',
                'myc_carrier_final_consumption_of_oil_and_oil_products_in_industry_ex_ict_and_refineries_non_energetic',
                'myc_carrier_final_consumption_of_oil_and_oil_products_in_industry_refineries_non_energetic',
                'myc_carrier_final_consumption_of_oil_and_oil_products_in_other_non_energetic',
              ],
            },
            {
              key: 'fec_non_energetic_carrier_liquid_biofuels',
              slug: 'liquid-biofuels',
              series: [
                'myc_carrier_final_consumption_of_liquid_biofuels_in_national_transport_non_energetic',
                'myc_carrier_final_consumption_of_liquid_biofuels_in_industry_ex_ict_and_refineries_non_energetic',
                'myc_carrier_final_consumption_of_liquid_biofuels_in_industry_refineries_non_energetic',
                'myc_carrier_final_consumption_of_liquid_biofuels_in_other_non_energetic',
              ],
            },
            {
              key: 'fec_non_energetic_carrier_gaseous_biofuels',
              slug: 'gaseous-biofuels',
              series: [
                'myc_carrier_final_consumption_of_gaseous_biofuels_in_national_transport_non_energetic',
                'myc_carrier_final_consumption_of_gaseous_biofuels_in_industry_ex_ict_and_refineries_non_energetic',
                'myc_carrier_final_consumption_of_gaseous_biofuels_in_industry_refineries_non_energetic',
                'myc_carrier_final_consumption_of_gaseous_biofuels_in_other_non_energetic',
              ],
            },
            {
              key: 'fec_non_energetic_carrier_solid_biofuels',
              slug: 'solid-biofuels',
              series: [
                'myc_carrier_final_consumption_of_solid_biofuels_in_national_transport_non_energetic',
                'myc_carrier_final_consumption_of_solid_biofuels_in_industry_ex_ict_and_refineries_non_energetic',
                'myc_carrier_final_consumption_of_solid_biofuels_in_industry_refineries_non_energetic',
                'myc_carrier_final_consumption_of_solid_biofuels_in_other_non_energetic',
              ],
            },
            {
              key: 'fec_non_energetic_carrier_solar_thermal',
              slug: 'solar-thermal',
              series: [
                'myc_carrier_final_consumption_of_solar_thermal_in_national_transport_non_energetic',
                'myc_carrier_final_consumption_of_solar_thermal_in_industry_ex_ict_and_refineries_non_energetic',
                'myc_carrier_final_consumption_of_solar_thermal_in_industry_refineries_non_energetic',
                'myc_carrier_final_consumption_of_solar_thermal_in_other_non_energetic',
              ],
            },
            {
              key: 'fec_non_energetic_carrier_geothermal',
              slug: 'geothermal',
              series: [
                'myc_carrier_final_consumption_of_geothermal_in_national_transport_non_energetic',
                'myc_carrier_final_consumption_of_geothermal_in_industry_ex_ict_and_refineries_non_energetic',
                'myc_carrier_final_consumption_of_geothermal_in_industry_refineries_non_energetic',
                'myc_carrier_final_consumption_of_geothermal_in_other_non_energetic',
              ],
            },
            {
              key: 'fec_non_energetic_carrier_renewable_waste',
              slug: 'renewable-waste',
              series: [
                'myc_carrier_final_consumption_of_renewable_waste_in_national_transport_non_energetic',
                'myc_carrier_final_consumption_of_renewable_waste_in_industry_ex_ict_and_refineries_non_energetic',
                'myc_carrier_final_consumption_of_renewable_waste_in_industry_refineries_non_energetic',
                'myc_carrier_final_consumption_of_renewable_waste_in_other_non_energetic',
              ],
            },
            {
              key: 'fec_non_energetic_carrier_non_renewable_waste',
              slug: 'non-renewable-waste',
              series: [
                'myc_carrier_final_consumption_of_non_renewable_waste_in_national_transport_non_energetic',
                'myc_carrier_final_consumption_of_non_renewable_waste_in_industry_ex_ict_and_refineries_non_energetic',
                'myc_carrier_final_consumption_of_non_renewable_waste_in_industry_refineries_non_energetic',
                'myc_carrier_final_consumption_of_non_renewable_waste_in_other_non_energetic',
              ],
            },
            {
              key: 'fec_non_energetic_carrier_heat',
              slug: 'heat',
              series: [
                'myc_carrier_final_consumption_of_heat_in_national_transport_non_energetic',
                'myc_carrier_final_consumption_of_heat_in_industry_ex_ict_and_refineries_non_energetic',
                'myc_carrier_final_consumption_of_heat_in_industry_refineries_non_energetic',
                'myc_carrier_final_consumption_of_heat_in_other_non_energetic',
              ],
            },
            {
              key: 'fec_non_energetic_carrier_electricity',
              slug: 'electricity',
              series: [
                'myc_carrier_final_consumption_of_electricity_in_national_transport_non_energetic',
                'myc_carrier_final_consumption_of_electricity_in_industry_ex_ict_and_refineries_non_energetic',
                'myc_carrier_final_consumption_of_electricity_in_industry_refineries_non_energetic',
                'myc_carrier_final_consumption_of_electricity_in_other_non_energetic',
              ],
            },
            {
              key: 'fec_non_energetic_carrier_hydrogen',
              slug: 'hydrogen',
              series: [
                'myc_carrier_final_consumption_of_hydrogen_in_national_transport_non_energetic',
                'myc_carrier_final_consumption_of_hydrogen_in_industry_ex_ict_and_refineries_non_energetic',
                'myc_carrier_final_consumption_of_hydrogen_in_industry_refineries_non_energetic',
                'myc_carrier_final_consumption_of_hydrogen_in_other_non_energetic',
              ],
            },
            {
              key: 'fec_non_energetic_carrier_ammonia',
              slug: 'ammonia',
              series: [
                'myc_carrier_final_consumption_of_ammonia_in_national_transport_non_energetic',
                'myc_carrier_final_consumption_of_ammonia_in_industry_ex_ict_and_refineries_non_energetic',
                'myc_carrier_final_consumption_of_ammonia_in_industry_refineries_non_energetic',
                'myc_carrier_final_consumption_of_ammonia_in_other_non_energetic',
              ],
            },
            {
              key: 'fec_non_energetic_carrier_methanol',
              slug: 'methanol',
              series: [
                'myc_carrier_final_consumption_of_methanol_in_national_transport_non_energetic',
                'myc_carrier_final_consumption_of_methanol_in_industry_ex_ict_and_refineries_non_energetic',
                'myc_carrier_final_consumption_of_methanol_in_industry_refineries_non_energetic',
                'myc_carrier_final_consumption_of_methanol_in_other_non_energetic',
              ],
            },
          ],
        },
      ],
    },
  ],
};
